import _ from 'lodash';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { enable, installHighlightStyle, pubWithoutDebounce, type SimpleHighlightConfig } from '@patsnap-utils/highlight';

export const CustomHighlightService = Symbol('CustomHighlightService');

export interface CustomHighlightService {
    initialize: (namespace: string) => void;
    pushHighlight: (highlightList: SimpleHighlightConfig[]) => void;
    dispose: () => void;
}

const DEBOUNCE_TIME = 500;

@injectable()
export class CustomHighlightServiceImpl implements CustomHighlightService {
    private _pushHighlight: _.DebouncedFunc<(highlightList: SimpleHighlightConfig[]) => void> | null = null;
    private _isInitialized = false;

    public initialize(namespace: string) {
        enable(namespace)(true);
        installHighlightStyle(namespace);

        this._pushHighlight = _.debounce((highlightList: SimpleHighlightConfig[]) => {
            pubWithoutDebounce(highlightList);
        }, DEBOUNCE_TIME);

        this._isInitialized = true;
    }

    public pushHighlight(highlightList: SimpleHighlightConfig[]) {
        if (!this._isInitialized) throw new Error('CustomHighlightService is not initialized');
        this._pushHighlight?.(highlightList);
    }

    public dispose() {
        this._pushHighlight?.cancel();
        this._pushHighlight = null;
    }
}
